export const mutations = {
  addToken(state, token) {
    state.token = token
  },
  setToken(state, token) {
    state.token = token
  },
  addTokens(state, token) {
    state.tokens = token
  },
  addTokensPage(state, token) {
    state.tokens = token
  },
}
